var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJournal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.36 20.6H15.75V81.3H62.36V20.6Z",
    fill: "#FBC8BD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.59 33.22H51.52",
    stroke: "#D26758",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.59 45.14H51.52",
    stroke: "#D26758",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.59 57.06H51.52",
    stroke: "#D26758",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.59 68.99H51.52",
    stroke: "#D26758",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3299 32.74C84.5166 32.74 87.0999 30.1567 87.0999 26.97C87.0999 23.7833 84.5166 21.2 81.3299 21.2C78.1433 21.2 75.5599 23.7833 75.5599 26.97C75.5599 30.1567 78.1433 32.74 81.3299 32.74Z",
    fill: "#C75E5A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4153 31.0575L77.2412 22.8834L49.9684 50.1563L58.1424 58.3304L85.4153 31.0575Z",
    fill: "#C75E5A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3766 33.0948L75.2025 24.9208L49.9661 50.1572L58.1402 58.3312L83.3766 33.0948Z",
    fill: "#F9907B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3344 35.1421L73.1603 26.968L48.8573 51.271L57.0313 59.4451L81.3344 35.1421Z",
    fill: "#C75E5A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M48.85 51.27L45.86 62.44L46.75 59.11L49.19 61.54L45.86 62.44L57.02 59.45L48.85 51.27Z",
    fill: "#F9907B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M46.75 59.11L46.01 61.87C45.94 62.12 46.17 62.36 46.43 62.29L49.19 61.55L46.75 59.11Z",
    fill: "#C75E5A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJournal);
export default __webpack_public_path__ + "static/media/Journal.189ad10f428ff5d2bbcd1aa57643bec6.svg";
export { ForwardRef as ReactComponent };